import New from './AccountsNew'
import Main from './AccountsMain'
import Show from './AccountsShow'

const Accounts = {
  New,
  Main,
  Show,
}

export default Accounts
